import React from "react";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import { ExternalLink } from "components/common";
import { UnlicensedText } from "components/loggers/ClusterSupportBundleInfo";
import { LICENSE_SUBJECTS } from "license/constants";
const EnterpriseSupportBundleInfo = () => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  const {
    data: { valid },
    isInitialLoading: isLoading
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  if (isLoading) {
    return null;
  }
  if (!valid) {
    return /* @__PURE__ */ React.createElement(UnlicensedText, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, t("support_bundle.examine", { productName })), /* @__PURE__ */ React.createElement("br", null), t("support_bundle.after_examination"), " \xA0", /* @__PURE__ */ React.createElement(ExternalLink, { href: t("support_bundle.support_url") }, t("support_bundle.support_url")));
};
export default EnterpriseSupportBundleInfo;
